import { Injectable, Inject } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import {
  ENVIRONMENT,
  Environment,
  SDKConfiguration,
  SDK_CONFIGURATION,
} from '../../models/config.model'
import { SDK_SETTINGS } from '../../consts/config.const'
import { ClientType } from './models/version.types'
import { ClientVersion } from './models/version.entity'

const MODEL = 'versions'
const VERSION = 'v2'

@Injectable({
  providedIn: 'root',
})
export class VersionsService {
  private _client?: ClientType
  private apiUrl: string

  constructor(
    @Inject(SDK_CONFIGURATION) config: SDKConfiguration,
    @Inject(ENVIRONMENT) environment: Environment,
    private http: HttpClient,
  ) {
    /* this._client = config.client === 'WEB' ? 'web' : 'repod' */
    this._client = this.resolveClient(config, environment)
    this.apiUrl = `${config.apiUrl}/${SDK_SETTINGS.apiPath}/${VERSION}/${MODEL}`
  }

  /**
   * Get current client
   */
  get client(): ClientType | undefined {
    return this._client
  }

  /**
   * Get version of the client
   * @param client - the client type
   * @returns the obsevable for load the client version
   */
  geClientVersion$(client: ClientType | undefined): Observable<ClientVersion> {
    return this.http.get<ClientVersion>(`${this.apiUrl}/${client ?? 'web'}`)
  }

  private resolveClient(
    config: SDKConfiguration,
    environment: Environment,
  ): ClientType {
    if (environment.configuration === 'fresh') return 'web-fresh'

    // fallback URL just to be safe
    if (typeof location !== 'undefined' && /fresh/i.test(location.hostname)) {
      return 'web-fresh'
    }

    return config.client === 'WEB' ? 'web' : 'repod'
  }
}
